// import React from "react";
import Decimal from "decimal.js-light";

import { getSum, getNonCancelledItems } from "../../helpers/methods";
import { DISCOUNT_TYPE_PERCENTAGE, DISCOUNT_TYPE_VALUE } from "./common";

export const useGetDiscountValue = (props) => {
  const {
    orderItems = [],
    voucher = null,
    shippingCost: tempShippingCost = 0,
  } = props;

  const shippingCost = tempShippingCost ?? 0;
  const items = orderItems.filter(getNonCancelledItems);

  const merchandiseTotal = new Decimal(getSum(items));
  const shippingDecimal = new Decimal(shippingCost);
  const ZERO = new Decimal(0);

  if (!voucher) {
    return {
      totalDiscount: ZERO,
      discountForItems: ZERO,
      discountForShipping: ZERO,
    };
  }

  const {
    value,
    discountType,
    maxDiscount = 0,
    discountAfterShipping,
  } = voucher;

  let discountForItems = ZERO;
  let discountForShipping = ZERO;

  const rawValueDecimal = new Decimal(value);
  const cappedValueDecimal =
    discountType === DISCOUNT_TYPE_PERCENTAGE &&
    rawValueDecimal.greaterThan(100)
      ? new Decimal(100)
      : rawValueDecimal;
  const maxDecimal = new Decimal(maxDiscount);

  // === ITEM DISCOUNT CALCULATION ===
  if (merchandiseTotal.greaterThan(0)) {
    if (discountType === DISCOUNT_TYPE_PERCENTAGE) {
      discountForItems = merchandiseTotal
        .times(cappedValueDecimal)
        .dividedBy(100);
      if (maxDiscount > 0 && discountForItems.greaterThan(maxDecimal)) {
        discountForItems = maxDecimal;
      }
    } else {
      discountForItems = rawValueDecimal;
      if (discountForItems.greaterThan(merchandiseTotal)) {
        discountForItems = merchandiseTotal;
      }
    }
  }

  // === SHIPPING DISCOUNT CALCULATION ===
  if (discountAfterShipping && shippingDecimal.greaterThan(0)) {
    if (discountType === DISCOUNT_TYPE_PERCENTAGE) {
      discountForShipping = shippingDecimal
        .times(cappedValueDecimal)
        .dividedBy(100);
      if (maxDiscount > 0) {
        const maxShippingDiscount = maxDecimal.minus(discountForItems);
        if (discountForShipping.greaterThan(maxShippingDiscount)) {
          discountForShipping = maxShippingDiscount;
        }
      }
    } else {
      let remaining = rawValueDecimal.minus(discountForItems);
      if (remaining.lessThan(ZERO)) remaining = ZERO;
      discountForShipping = remaining;
      if (discountForShipping.greaterThan(shippingDecimal)) {
        discountForShipping = shippingDecimal;
      }
    }
  }

  const totalDiscount = discountForItems.plus(discountForShipping);

  return {
    totalDiscount: totalDiscount.todp(2).toFixed(2),
    discountForItems: discountForItems.todp(2).toFixed(2),
    discountForShipping: discountForShipping.todp(2).toFixed(2),
  };
};

export const getGetDiscountValue = useGetDiscountValue;
